/* vim: set expandtab sw=2 ts=2 sts=2: */
import React from 'react';
import PropTypes from 'prop-types';

const Todo = ({ onClick, completed, text }) => ( 
  <li 
    onClick={onClick} 
    style={{ textDecoration: completed ? 'line-through' : 'none' }} 
  >
    {text}
  </li>
);

Todo.PropTypes = {
    onClick: PropTypes.func.isRequired, 
    completed: PropTypes.bool.isRequired, 
    text: PropTypes.string.isRequired
}

export default Todo



// WEBPACK FOOTER //
// ./usr/lib/ui/src/containers/todos/Todo.js